import SnowflakeConfig from './Snowflake';
import RedshiftConfig from './Redshift';
import BigQueryConfig from './BigQuery';

export default {
  snowflake: SnowflakeConfig,
  redshift: RedshiftConfig,
  bigquery: BigQueryConfig,
};
